import axios, { ApiResponse, ApiRoutes, ErrorResponse } from "@/api/client";
import { User } from "@/types";

const getUser: () => Promise<User> = () => {
  return axios
    .get(ApiRoutes.USER)
    .then((response: ApiResponse<User>) => {
      return response.data.data;
    })
    .catch((reason: ErrorResponse) => {
      const e = {
        error: {
          message: reason.response?.data?.message || "Failed to fetch user details.",
          suppressGlobalNotification: true,
          statusCode: reason.response?.status,
        },
      };
      throw e;
    });
};

const getUsers: () => Promise<User[]> = () => {
  return axios
    .get(ApiRoutes.USERS)
    .then((response: ApiResponse<{ users: User[] }>) => {
      return response.data.data.users;
    })
    .catch((reason: ErrorResponse) => {
      const e = {
        error: {
          message: reason.response?.data?.message || "Failed to fetch users.",
          suppressGlobalNotification: true,
          statusCode: reason.response?.status,
        },
      };
      throw e;
    });
};

const UserService = {
  getUser,
  getUsers,
};
export default UserService;
